import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from '../services/apiSlice';
import { firebaseApiSlice } from '../services/firebaseApiSlice';
import { financeApiSlice } from '../services/financeApiSlice';
import { usersApiSlice } from '../services/usersApiSlice';
import { tabbedDictApi as tabbedDictApiSlice } from '../services/tabbedDictApiSlice';
import authReducer from '../features/auth/authSlice';
import financeReducer from '../features/finance/financeSlice';
import {uidDictApi} from '../services/uidDictApiSlice';

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [firebaseApiSlice.reducerPath]: firebaseApiSlice.reducer,
    [financeApiSlice.reducerPath]: financeApiSlice.reducer,
    [usersApiSlice.reducerPath]: usersApiSlice.reducer,
    [tabbedDictApiSlice.reducerPath]: tabbedDictApiSlice.reducer,
    [uidDictApi.reducerPath]: uidDictApi.reducer,
    auth: authReducer,
    finance: financeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      apiSlice.middleware,
      firebaseApiSlice.middleware,
      financeApiSlice.middleware,
      usersApiSlice.middleware,
      tabbedDictApiSlice.middleware,
      uidDictApi.middleware,
    ),
});

export default store;
